module.exports = __webpack_public_path__ + "media/Audio18_c.0770c270.wav";